import store from 'Store/index';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';

export function potentialTabAllowed() {
	const hasCustomerPortfolioPotential = isAvailable(Feature.CUSTOMER_PORTFOLIO_POTENTIAL);
	const hasFullReportAccess = store.getState().App.hasFullReportAccess ?? false;

	return hasCustomerPortfolioPotential && hasFullReportAccess;
}

export default function allowed() {
	return true;
}
